// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/integrations/integrations.actions.go

import { type Scope } from "~/hooks/useScope";
import { TRIGGER_ACTION } from "./action";

export function canTriggerAction(scope: Scope): boolean {
  return scope.iamActions.includes(TRIGGER_ACTION);
}
